import React from 'react';
import { ChevronDown } from 'lucide-react';
import danceHero from '../assets/images/dance-hero.jpg';

const Hero = () => {
  return (
    <header id="home" className="relative h-screen flex items-center justify-center bg-black text-white">
      <div className="absolute inset-0">
        <img 
          src={danceHero}
          alt="Dance performance"
          className="w-full h-full object-cover opacity-20"
        />
      </div>
      <div className="relative z-10 text-center px-4">
        <h1 className="text-6xl font-bold mb-6 text-red-700">Rueda de la Vida</h1>
        <p className="text-2xl mb-8">Salsa Dance Classes & Socials</p>
        <p className="text-xl">Vancouver, BC</p>
        <ChevronDown className="mx-auto mt-12 animate-bounce text-red-700" size={48} />
      </div>
    </header>
  );
};

export default Hero;